type PropsType = {
  fill?: string;
};

const NawyNowIcon = ({ fill }: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.8435 3.16591C12.6235 0.953406 9.02346 0.953406 6.81846 3.16591C5.26596 4.70341 4.80096 6.91591 5.40096 8.86591L1.87596 12.3909C1.62846 12.6459 1.45596 13.1484 1.50846 13.5084L1.73346 15.1434C1.81596 15.6834 2.31846 16.1934 2.85846 16.2684L4.49346 16.4934C4.85346 16.5459 5.35596 16.3809 5.61096 16.1184L6.22596 15.5034C6.37596 15.3609 6.37596 15.1209 6.22596 14.9709L4.77096 13.5159C4.55346 13.2984 4.55346 12.9384 4.77096 12.7209C4.98846 12.5034 5.34846 12.5034 5.56596 12.7209L7.02846 14.1834C7.17096 14.3259 7.41096 14.3259 7.55346 14.1834L9.14346 12.6009C11.086 13.2084 13.2985 12.7359 14.8435 11.1984C17.056 8.98591 17.056 5.37841 14.8435 3.16591ZM10.876 9.00091C9.84096 9.00091 9.00096 8.16091 9.00096 7.12591C9.00096 6.09091 9.84096 5.25091 10.876 5.25091C11.911 5.25091 12.751 6.09091 12.751 7.12591C12.751 8.16091 11.911 9.00091 10.876 9.00091Z"
        fill={fill ?? '#FF5E00'}
      />
    </svg>
  );
};

export default NawyNowIcon;
